import axios from "axios";
import React, { Component } from "react";
// get our fontawesome imports
import { faHeart, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Countdown from "react-countdown";
import Scrollspy from "react-scrollspy";
import { Helmet } from "react-helmet";
import SweetAlert from "react-bootstrap-sweetalert";
import AudioWedding from "./components/AudioWedding";
import VolumeButton from "./components/VolumeButton";
import LoadingScreen from "./components/LoadingScreen";
import moment from "moment";
require("moment/locale/id");

class WeddingV1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wedding: {},
      undangan: {},
      muted: false,
      isReady: false,
      alert: null,
    };
    this.handleMute = this.handleMute.bind(this);
  }

  componentDidMount() {
    const wedUsername = this.props.match.params.username;
    axios.get(`${window.localhost}/wedding/${wedUsername}`).then((response) => {
      this.setState({
        wedding: response.data,
      });

      // Undangan
      if (this.props.match.params.permalink) {
        const wedPermalink = this.props.match.params.permalink;
        axios
          .get(`${window.localhost}/getundangan/${wedUsername}/${wedPermalink}`)
          .then((response) => {
            this.setState({
              undangan: response.data,
            });
            if (response.data) {
              setTimeout(() => this.showUndangan(), 3000);
            }
          });
      }
      setTimeout(
        () =>
          this.setState({
            isReady: true,
          }),
        2000
      );
    });
  }

  showUndangan() {
    const { undangan, wedding } = this.state;
    const tanggal = moment(wedding.tanggal, "YYYY-MM-DD").format("DD");
    const bulan = moment(wedding.tanggal, "YYYY-MM-DD").format("MMMM");
    const tahun = moment(wedding.tanggal, "YYYY-MM-DD").format("YYYY");
    const getAlert = () => (
      <SweetAlert
        title=""
        confirmBtnText="Close"
        confirmBtnBsStyle="default"
        btnSize="xs"
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        focusConfirmBtn
        showCloseButton={true}
        customClass="w-md-75 w-100 pt-5 px-0"
      >
        <div
          className="bg-undangan"
          style={{
            backgroundImage: `url(/img/aset-undangan-atas.png), url(/img/aset-undangan-bawah.png)`,
          }}
        >
          <span className="display-2 font-great-vibes">
            {wedding.namesuami} & {wedding.nameistri}
          </span>
          <hr className="col-md-6 col-8 mx-auto" />
          <p className="font-poppins">Assalamu alaikum wr. wb.</p>
          <p className="font-poppins">Kepada Yth. Bapak/Ibu/Saudara/i:</p>
          <h2 className="font-libre badge bg-light text-dark px-4 fs-3">
            {undangan.fullname}
          </h2>
          <p className="col-10 mx-auto font-poppins">
            Dengan memohon rahmat & ridho Allah Swt. kami bermaksud
            menyelenggarakan akad nikah & resepsi pernikahan yang insyaAllah
            akan dilaksanakan pada:
          </p>
          <h2 className="font-libre badge bg-light text-dark px-4 fs-3">
            {tanggal} {bulan} {tahun}
          </h2>
          <p className="font-poppins">Lokasi:</p>
          <p className="col-10 bg-light rounded-1 py-2 mx-auto font-libre px-4 mt-3">
            {wedding.desclokasi}
          </p>
          <p className="col-10 mx-auto font-poppins">
            Merupakan kehormatan bagi kami apabila {undangan.panggilan} berkenan
            hadir di acara kami. Atas kehadiran dan doa restunya, kami ucapkan
            terima kasih.
          </p>
          <p className="font-poppins">Wassalamu alaikum wr. wb.</p>
        </div>
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleMute() {
    if (this.state.muted) {
      this.setState({
        muted: false,
      });
    } else {
      this.setState({
        muted: true,
      });
    }
  }

  scriptJs() {
    // NAVBAR EFFECT
    window.onscroll = function () {
      myNavbar();
    };
    function myNavbar() {
      var x = document.getElementById("myNav");
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        x.classList.add("shadow-nav");
        x.classList.add("bg-white");
        x.classList.add("text-dark");
        x.classList.remove("bg-transparent");
        x.classList.remove("text-light");
      } else {
        x.classList.remove("shadow-nav");
        x.classList.remove("bg-white");
        x.classList.remove("text-dark");
        x.classList.add("bg-transparent");
        x.classList.add("text-light");
      }
    }
    // END NAVBAR EFFECT
  }

  render() {
    const { wedding } = this.state;

    const imgpath = `${window.localhost}/img/`;
    const musicpath = `${window.localhost}/music/`;

    let suami = wedding.namesuami;
    let istri = wedding.nameistri;

    const tanggal = moment(wedding.tanggal, "YYYY-MM-DD").format("DD");
    const bulan = moment(wedding.tanggal, "YYYY-MM-DD").format("MMMM");
    const tahun = moment(wedding.tanggal, "YYYY-MM-DD").format("YYYY");

    const date_lengkap = moment(wedding.tanggal, "YYYY-MM-DD").format(
      "DD MMMM YYYY"
    );

    const hmin = moment(wedding.tanggal, "YYYY-MM-DD").diff(moment(), "days");

    // Random component
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
      if (completed) {
        // Render a completed state
        return <Completionist />;
      } else {
        // Render a countdown
        return (
          <div>
            <span>{hmin} hari</span>
            <span>{hours} jam</span>
            <span>{minutes} menit</span>
            <span>{seconds} detik</span>
          </div>
        );
      }
    };

    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>
              {`${wedding.namesuami} & ${wedding.nameistri} Wedding Invitation by
            CreatifaStudio`}
            </title>
            <meta
              name="description"
              content={`${wedding.namesuami} & ${wedding.nameistri} Wedding Invitation by CreatifaStudio`}
            />
          </Helmet>
          <nav
            className="navbar navbar-expand-lg text-light fixed-top bg-transparent py-3 trans-all"
            id="myNav"
          >
            <div className="container font-poppins d-flex justify-content-between">
              <div className="px-3">
                <span className="fs-4 fw-800">
                  {wedding.namesuami} & {wedding.nameistri}
                </span>
              </div>

              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
                className="btn btn-outline-pink d-md-none d-flex"
              >
                <FontAwesomeIcon icon={faBars} />
              </button>

              <Scrollspy
                items={[
                  "section1",
                  "section2",
                  "section3",
                  "section4",
                  "section5",
                  "section6",
                ]}
                offset={0}
                currentClassName="is-active2"
                className="nav nav-pills d-md-flex d-none"
              >
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section2">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section3">
                    Count Down
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section4">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section5">
                    Contact
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section6">
                    Gallery
                  </a>
                </li>
              </Scrollspy>
            </div>
          </nav>

          <div
            className="offcanvas offcanvas-start w-75"
            tabIndex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                {wedding.namesuami} & {wedding.nameistri}
              </h5>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <Scrollspy
                items={[
                  "section1",
                  "section2",
                  "section3",
                  "section4",
                  "section5",
                  "section6",
                ]}
                offset={0}
                currentClassName="is-active2"
                className="nav nav-pills d-md-none d-block"
              >
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section2">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section3">
                    Count Down
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section4">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section5">
                    Contact
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section6">
                    Gallery
                  </a>
                </li>
              </Scrollspy>
            </div>
          </div>

          <div id="section1" className="container-fluid overflow-hidden px-0">
            <div
              id="carouselExampleCaptions"
              className="carousel slide carousel-fade mx-0"
              data-bs-ride="carousel"
              data-bs-pause="false"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide-to="0"
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide-to="1"
                  aria-label="Slide 2"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide-to="2"
                  aria-label="Slide 3"
                ></button>
              </div>

              <div className="carousel-inner">
                <div className="main-heading">
                  <h1 className="main-title display-v2">
                    Save
                    <br />
                    The Date
                    <div className="display-4 the-date">
                      - {tanggal}
                      <span className="text-pink">.</span>
                      {bulan}
                      <span className="text-pink">.</span>
                      {tahun} -
                    </div>
                  </h1>
                  <div className="col-12 col-sm-5 mx-auto">
                    <hr />
                    <p className="fs-4">{wedding.descheader}</p>
                    <hr />
                  </div>
                </div>
                <div
                  className="carousel-item active"
                  style={{
                    backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgslide1})`,
                  }}
                >
                  <div className="carousel-caption overlay-color"></div>
                </div>
                <div
                  className="carousel-item"
                  style={{
                    backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgslide2})`,
                  }}
                >
                  <div className="carousel-caption overlay-color"></div>
                </div>
                <div
                  className="carousel-item"
                  style={{
                    backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgslide3})`,
                  }}
                >
                  <div className="carousel-caption overlay-color"></div>
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div
            id="section2"
            className="container-fluid overflow-hidden bg-light px-0"
          >
            <div className="container wrapper">
              <div className="row text-center">
                <h1 className="sec-title fw-bold">{wedding.title2}</h1>
                <p className="py-3 fs-5 text-secondary">{wedding.desc2}</p>
              </div>
              <div className="row">
                <div className="text-center">
                  <div className="grey-line me-2"> </div>
                  <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                  <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                  <div className="grey-line ms-2"> </div>
                </div>
              </div>

              <div className="row row-cols-1 row-cols-md-2 g-4 mt-5">
                <div className="col">
                  <div className="card bg-transparent border-0">
                    <div
                      className="person-pict w-100 rounded-4 overflow-hidden"
                      style={{
                        backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgsuami})`,
                      }}
                    ></div>
                    <div className="card-body px-0">
                      <h5 className="card-title fs-4 fw-bold">
                        {wedding.fullnamesuami}
                      </h5>
                      <p className="card-text text-desc text-secondary">
                        {wedding.descsuami}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card bg-transparent border-0">
                    <div
                      className="person-pict w-100 rounded-4 overflow-hidden"
                      style={{
                        backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgistri})`,
                      }}
                    ></div>
                    <div className="card-body px-0">
                      <h5 className="card-title fs-4 fw-bold">
                        {wedding.fullnameistri}
                      </h5>
                      <p className="card-text text-desc text-secondary">
                        {wedding.descistri}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="section3"
            className="container-fluid overflow-hidden bg-light px-0"
          >
            <div
              className="semifull-screen"
              style={{
                backgroundImage: `url(https://cdn.pixabay.com/photo/2016/03/27/20/54/wedding-reception-1284245_960_720.jpg)`,
              }}
            >
              <div className="overlay-card">
                <div className="v-h-centered text-center">
                  <h1 className="main-title display-v2">
                    Counting
                    <br />
                    Down
                  </h1>
                  <div className="row mt-3">
                    <div className="text-center">
                      <div className="grey-line me-2"> </div>
                      <FontAwesomeIcon
                        icon={faHeart}
                        className="fs-4 pink-heart"
                      />
                      <FontAwesomeIcon
                        icon={faHeart}
                        className="fs-4 white-heart"
                      />
                      <div className="grey-line ms-2"> </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="count-down fs-4">
                      <Countdown date={date_lengkap} renderer={renderer} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="section4"
            className="container-fluid overflow-hidden bg-light px-0"
          >
            <div className="container wrapper">
              <div className="row text-center">
                <h1 className="sec-title fw-bold">{wedding.title3}</h1>
                <p className="py-3 fs-5 text-secondary">{wedding.desc3}</p>
              </div>
              <div className="row">
                <div className="text-center">
                  <div className="grey-line me-2"> </div>
                  <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                  <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                  <div className="grey-line ms-2"> </div>
                </div>
              </div>
              <div className="row row-cols-1 row-cols-md-3 g-4 mt-5">
                <div className="col">
                  <div className="card h-100 border-0 rounded-4 shadow-md">
                    <div
                      className="wedding-pict w-100 rounded-4 overflow-hidden"
                      style={{
                        backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imglokasi})`,
                      }}
                    ></div>
                    <div className="card-body">
                      <h5 className="card-title">Lokasi</h5>
                      <p className="card-text">{wedding.desclokasi}</p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card h-100 border-0 rounded-4 shadow-md">
                    <div
                      className="wedding-pict w-100 rounded-4 overflow-hidden"
                      style={{
                        backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgakad})`,
                      }}
                    ></div>
                    <div className="card-body">
                      <h5 className="card-title">Akad Nikah</h5>
                      <p className="card-text">{wedding.descakad}</p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card h-100 border-0 rounded-4 shadow-md">
                    <div
                      className="wedding-pict w-100 rounded-4 overflow-hidden"
                      style={{
                        backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgresepsi})`,
                      }}
                    ></div>
                    <div className="card-body">
                      <h5 className="card-title">Resepsi Pernikahan</h5>
                      <p className="card-text">{wedding.descresepsi}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="section5"
            className="container-fluid overflow-hidden bg-white px-0"
          >
            <div className="container wrapper">
              <div className="row">
                <div className="text-center">
                  <div className="grey-line me-2"> </div>
                  <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                  <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                  <div className="grey-line ms-2"> </div>
                </div>
              </div>
              <div className="row mt-4">
                <h1 className="sec-title fw-bold text-center">
                  {wedding.title4}
                </h1>
                <p className="py-3 fs-5 text-secondary text-center">
                  {wedding.desc4}
                </p>
                <div className="d-grid">
                  <a
                    href={`http://api.whatsapp.com/send/?phone=${wedding.nohp}`}
                    target="_blank"
                    rel="noreferrer"
                    type="button"
                    className="btn btn-outline-pink px-4 mx-auto text-decoration-none"
                  >
                    Hubungi Kami
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-light" id="section6">
            <div className="container-fluid wrapper-y-sm px-4">
              <div className="row mt-4">
                <h1 className="sec-title fw-bold text-center">
                  Gallery Photos
                </h1>
              </div>
              <div className="row mt-3 text-center">
                <div className="text-center">
                  <div className="grey-line me-2"> </div>
                  <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                  <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                  <div className="grey-line ms-2"> </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-4 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide1})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-3 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide2})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-5 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide3})`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imglokasi})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-5 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgakad})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-4 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgresepsi})`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid overflow-hidden bg-light px-0">
            <div
              className="semifull-screen"
              style={{
                backgroundImage: `url(https://cdn.pixabay.com/photo/2016/03/27/20/54/wedding-reception-1284245_960_720.jpg)`,
              }}
            >
              <div className="overlay-card">
                <div className="v-h-centered text-center">
                  <h1 className="main-title display-v2">
                    Thank
                    <br />
                    You
                  </h1>
                  <div className="row mt-5">
                    <div className="text-center">
                      <div className="grey-line me-2"> </div>
                      <FontAwesomeIcon
                        icon={faHeart}
                        className="fs-4 pink-heart"
                      />
                      <FontAwesomeIcon
                        icon={faHeart}
                        className="fs-4 white-heart"
                      />
                      <div className="grey-line ms-2"> </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="count-down fs-4">
                      <span>
                        {suami} & {istri}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid bg-light">
            <div className="row py-4">
              <ul className="nav justify-content-center text-center">
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-secondary" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-secondary" href="#section2">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-secondary" href="#section3">
                    Count Down
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-secondary" href="#section4">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-secondary" href="#section5">
                    Contact
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-secondary" href="#section6">
                    Gallery
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <AudioWedding
            muted={this.state.muted}
            musicurl={`${musicpath}/${wedding.youtubecode}`}
          />
          <VolumeButton handleMute={this.handleMute} muted={this.state.muted} />
          <div className="container-fluid pt-3 pb-1 w-100 bg-white">
            <p className="text-center">
              Crafted with ❤️ by{" "}
              <a
                href="creatifastudio.com"
                className="text-dark text-decoration-none"
              >
                CreatifaStudio
              </a>
            </p>
          </div>
          {this.state.alert}
          {this.scriptJs()}
        </div>
      );
    }
  }
}

export default WeddingV1;
